module.exports = __webpack_public_path__ + "media/images/help/first-step-982d8eac989b2bd1a6e549b415c12779.png";